<script setup lang="ts">
import type { Component } from 'vue';

const props = withDefaults(
  defineProps<{
    icon: Component;
    size?: 'sm' | 'md';
  }>(),
  {
    size: 'md'
  }
);

const rawIcon = toRaw(props.icon);
</script>

<template>
  <div
    class="flex items-center justify-center rounded-full bg-slate-100"
    :class="{
      'h-21 w-21': size === 'sm',
      'h-28 w-28': size === 'md'
    }"
  >
    <component
      :is="rawIcon"
      class="text-slate-500"
      :class="{
        'h-8 w-8': size === 'sm',
        'h-12 w-12': size === 'md'
      }"
    />
  </div>
</template>
